interface ILoaderProps {
    size?: number;
    borderWidth?: number;
    align?: "left" | "center" | "right";
}

export default function Loader(props: ILoaderProps) {
    const { size, borderWidth, align } = props
    return (
        <div
            style={{
                justifyContent: `${align ?? "center"}`
            }}
            className={"flex w-full"}>
            <div
                style={{
                    width: `${size ?? 50}px`,
                    height: `${size ?? 50}px`,
                    borderWidth: `${borderWidth ?? 4}px`,
                }}
                className={`aspect-square rounded-full bg-transparent border-t-primary-700 animate-spin`}
            >
            </div>
        </div>
    )
}